import { render, staticRenderFns } from "./SizeContainer.vue?vue&type=template&id=1ed50509&"
import script from "./SizeContainer.vue?vue&type=script&lang=js&"
export * from "./SizeContainer.vue?vue&type=script&lang=js&"
import style0 from "./SizeContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports